import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var n=c=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 512 512",fill:"currentColor"},c),{children:jsx("path",{d:"M48 416l0-256 184 0 0 272L64 432c-8.8 0-16-7.2-16-16zm232 16l0-272 184 0 0 256c0 8.8-7.2 16-16 16l-168 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"})})),s=n;

export { s as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-K2GYMCSC.mjs.map